import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function InitiativesIcon({ className }: IconProps) {
  return (
    <svg
      width="84"
      height="64"
      viewBox="0 0 84 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_634)">
        <path
          d="M25.1143 45.9543C27.0461 45.9543 28.6112 47.5129 28.6112 49.4368V51.1903C28.6112 53.1142 27.0461 54.6728 25.1143 54.6728V45.9543Z"
          fill="#00416B"
        />
        <path
          d="M17.5332 41.303H25.114V60.201C25.114 62.2954 23.4022 63.9757 21.3236 63.9757C19.245 63.9757 17.5332 62.271 17.5332 60.201V41.303Z"
          fill="#EAEDF8"
        />
        <path
          d="M54.3369 2.92236L24.5273 15.7078V40.7184L54.3369 53.5281V2.92236Z"
          fill="#EAEDF8"
        />
        <path
          d="M59.5947 19.4824V36.9436C65.8305 32.1217 65.8305 24.3043 59.5947 19.4824Z"
          fill="#00416B"
        />
        <path
          d="M56.9536 56.4262C55.5108 56.4262 54.3125 55.2572 54.3125 53.796V2.63014C54.3125 1.1933 55.4863 0 56.9536 0C58.4208 0 59.5946 1.16895 59.5946 2.63014V53.8204C59.5946 55.2816 58.4208 56.4505 56.9536 56.4505"
          fill="#00C4B3"
        />
        <path
          d="M13.1563 15.1232H23.3782C24.3563 15.1232 25.1389 15.9025 25.1389 16.8767V41.3028H13.1563C5.89345 41.3028 0 35.4337 0 28.2009C0 20.968 5.89345 15.0989 13.1563 15.0989"
          fill="#00C4B3"
        />
        <path
          d="M13.7192 35.4826C13.2301 35.4826 12.8389 35.0929 12.8389 34.6059V21.7961C12.8389 21.3091 13.2301 20.9194 13.7192 20.9194C14.2083 20.9194 14.5996 21.3091 14.5996 21.7961V34.6059C14.5996 35.0929 14.2083 35.4826 13.7192 35.4826Z"
          fill="#00416B"
        />
        <path
          d="M19.27 35.4826C18.7809 35.4826 18.3896 35.0929 18.3896 34.6059V21.7961C18.3896 21.3091 18.7809 20.9194 19.27 20.9194C19.7591 20.9194 20.1503 21.3091 20.1503 21.7961V34.6059C20.1503 35.0929 19.7591 35.4826 19.27 35.4826Z"
          fill="#00416B"
        />
        <path
          d="M8.16746 35.4826C7.67838 35.4826 7.28711 35.0929 7.28711 34.6059V21.7961C7.28711 21.3091 7.67838 20.9194 8.16746 20.9194C8.65654 20.9194 9.04781 21.3091 9.04781 21.7961V34.6059C9.04781 35.0929 8.65654 35.4826 8.16746 35.4826Z"
          fill="#00416B"
        />
        <path
          d="M77.7645 13.5646C78.009 13.5646 78.2291 13.662 78.4247 13.8325C82.0195 17.4124 84.0003 22.1856 84.0003 27.2511C84.0003 32.3165 82.0195 37.0654 78.4247 40.6453C78.0579 41.0106 77.471 41.0106 77.1042 40.6453C76.7374 40.28 76.7374 39.6955 77.1042 39.3302C80.3566 36.0913 82.1418 31.8051 82.1418 27.2267C82.1418 22.6484 80.3566 18.3622 77.1042 15.1232C76.7374 14.7579 76.7374 14.1735 77.1042 13.8082C77.2754 13.6377 77.5199 13.5403 77.7645 13.5403"
          fill="#00416B"
        />
        <path
          d="M74.243 17.8022C74.4875 17.8022 74.7076 17.8997 74.9032 18.0701C79.9653 23.1112 79.9653 31.3426 74.9032 36.3837C74.5364 36.749 73.9495 36.749 73.5827 36.3837C73.2159 36.0184 73.2159 35.4339 73.5827 35.0686C77.9356 30.7338 77.9356 23.6957 73.5827 19.3852C73.2159 19.0199 73.2159 18.4354 73.5827 18.0701C73.7539 17.8997 73.9984 17.8022 74.243 17.8022Z"
          fill="#00416B"
        />
        <path
          d="M70.6971 22.0639C70.9416 22.0639 71.1617 22.1613 71.3574 22.3318C74.0718 25.035 74.0718 29.4429 71.3574 32.1461C70.9905 32.5114 70.4036 32.5114 70.0368 32.1461C69.67 31.7808 69.67 31.1963 70.0368 30.831C71.015 29.8569 71.5285 28.5905 71.5285 27.2268C71.5285 25.863 70.9905 24.5966 70.0368 23.6225C69.67 23.2572 69.67 22.6727 70.0368 22.3074C70.208 22.137 70.4525 22.0396 70.6971 22.0396"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_634">
          <rect width="84" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
